module.exports = __webpack_public_path__ + "img/2.619a3ddc.png";